import HTMLImage from "@ext/markdown/elements/image/render/components/HTMLImage";

export default HTMLImage;
